import React, { useState } from "react";
import "./auth.css";
import { Btn } from "../../utils/utils";
// import { useNavigate } from 'react-router-dom';

const ChooseAuth = () => {
  const authOpt = ["Tenant", "Landlord", "Developer"];

  // const navigate = useNavigate();

  const [active, setActive] = useState("Tenant");

  const clickChoice = (item) => {
    setActive(item);
  };

  return (
    <div className="choose-auth">
      <h2>Sign up with PrimeProperty</h2>
      <h3>Choose your persona to create an account with us</h3>
      <div className="auth-options">
        {authOpt.map((item, i) => {
          return (
            <div
              onClick={() => clickChoice(item)}
              key={i}
              className={
                active === item
                  ? "home-btn_s  special-btn"
                  : "home-btn_trans-s special-btn"
              }
            >
              {item}
            </div>
          );
        })}
      </div>
      <div className="auth-btn">
        <Btn
          btnText={"Continue"}
          btnLink={
            active === "Tenant"
              ? "/auth/signup-opt"
              : active === "Landlord"
              ? "/auth/agent-signup"
              // : active === "Landlord"
              // ? "/auth/signup-opt"
              : active === "Developer"
              ? "/auth/dev-signup"
              : "/auth/signup-opt"
          }
          btnClass={"home-btn spe-btn"}
          btnWidth={"485px"}
        />
      </div>
    </div>
  );
};

export default ChooseAuth;
